import React, {PropTypes} from 'react';
const s = require('./pageTitle.scss');

const PageTitle = ({title, description}) => {
  return (
    <div>
      <h1 className={s.pageTitle} data-hook="page-title">{title}</h1>
      <p className={s.pageDescription} data-hook="page-description">{description}</p>
    </div>
  );
};

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default PageTitle;



// WEBPACK FOOTER //
// ./components/partial/PageTitle/PageTitle.js